module.exports = __webpack_public_path__ + "img/plus_btn.71988143.png";